import React, { useEffect, useState } from 'react';
import { getallhotels, getLinkedhotels, getView } from "../dbconnector/connector";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import moment from 'moment';

const HotelSelection = ({ isDisabled, data,active,t, valueneeded, userhotels, css, checkapproval, selectedDate}) => {
    const [hotels, setHotels] = useState([]);
    const [approvals, setApprovals] = useState([]);

    useEffect(() => {
        if (checkapproval) {
            getView("roosterapproved", "roosterdag", selectedDate)
                .then(response => response.status === 200 && response.json())
                .then(setApprovals)
                .catch(console.error);
        }
    }, [checkapproval, selectedDate]);



    useEffect(() => {
   //console.log("active", active)
        const fetchHotels = async () => {
            
            try {
                let res;
                 
                if (!userhotels) {
                    res = await getallhotels(active);
                    if (res.status === 200) {
                        //console.log("hotels", res.items)
                        setHotels(res.items);
                    }
                } else {
                    res = await getLinkedhotels();
                    if (res.status === 200) {
                        const data = await res.json();
                        setHotels(data);
                    }
                }
            } catch (error) {
                console.error("Error fetching hotels:", error);
            }
        };
        fetchHotels();
    }, [userhotels, approvals,active]);
    const testclick= (e, evt) => {
        // {function(evt){//console.log(evt)}}
        document.getElementById("hotelsList").innerText = e
        
       // //console.log("hellokes ; " , evt)
    }

    const getApprovalClass = (hotel) => {
        const match = approvals.find(
            item =>
                item.hotel_Id === hotel.Hotel_ID &&
                moment(new Date(item.roosterdag).toLocaleDateString('en-CA')).format("YYYY-MM-DD") === selectedDate
        );
      
        if (match) {
              ////console.log("match.approved :", match.approved )
              //  //console.log("hotel.nr_afd: ", hotel.nr_afd)
            return match.approved === 1 ? "Approved" : "NotApproved";
        }
        
        return "NotCreated";
    };

    return (

        <select
            id="hotelsList"
            className={css}
            value={data.selectedhotel}
            onChange={data.handleitemchange}
            name={data.fieldname}
            disabled={isDisabled}
        ><option key="0" value={-1} >- selecteer een hotel -</option>
            {hotels.map((hotel, index) => {

                const approvalclass = getApprovalClass(hotel)
                const className = checkapproval ? approvalclass?approvalclass : "":"";
                let isApproved = "Approved -"
                if(!approvalclass){
                    isApproved = "Not approved -"
                }
                if(!checkapproval){
                    isApproved = ""
                }
                 const hotelId = hotel.HOTEL_ID||hotel.Hotel_ID; // to support both sources

                const value = valueneeded === "hotel_id" ? hotelId : hotel.nr_afd;

                const label = checkapproval?`${isApproved} ${hotel.nr_afd || hotelId} - ${hotel.Name}`:`${hotel.nr_afd || hotelId} - ${hotel.Name}`;
                

                return (
                    <option key={index} value={value} className={className}>
                        {label}
                    </option>
                );
            })}
        </select>
    );
};

export default HotelSelection;
